import gql from 'graphql-tag';

export const QUERY_GET_AUCTIONS = gql`
  query GetAuctions($input: GetAuctions!) {
    auctions(auctions: $input) {
      auctions {
        id
        name
        description
        startTime
        endTime
        status
        minimumBid
        bidIncrement
        bids {
          user {
            userId
            displayName
            avatarData
          }
          bidTime
          amount
        }
        totalBidsCount
        prizes {
          prizes {
            id
            name
            category
            url
          }
        }
        winner {
          user {
            userId
            displayName
            avatarData
          }
          bid
          awardPrizeStatuses {
            prizeId
            success
            prizeCode
          }
        }
        extendedEndTime
      }
    }
  }
`;

export const QUERY_GET_BIDS = gql`
  query GetAuctionBids($input: GetAuctionBids!) {
    auctionBids(auctionBids: $input) {
      auctionBids {
        auctionId
        user {
          userId
          displayName
          avatarData
        }
        bidTime
        amount
      }
    }
  }
`;

export const QUERY_GET_AUCTION = gql`
  query GetAuction($input: GetAuction!) {
    auction(input: $input) {
      id
      name
      description
      startTime
      endTime
      status
      minimumBid
      bidIncrement
      prizes {
        prizes {
          id
          name
          category
          url
        }
      }
      winner {
        user {
          userId
          displayName
          avatarData
        }
        bid
      }
      userInGroup
      bids {
        user {
          userId
          displayName
          avatarData
        }
        bidTime
        amount
      }
      lastOwnBid {
        bidTime
        amount
      }
      totalBidsCount
      thresholdGap
      incrementGap
      renewalCount
      extendedEndTime
    }
  }
`;

export const SUBSCRIPTION_AUCTION_EVENT = gql`
  subscription AuctionEvent {
    auctionEvents {
      id
      event
      name
      description
      bids {
        user {
          userId
          displayName
          avatarData
        }
        bidTime
        amount
      }
      totalBidsCount
      startTime
      endTime
      minimumBid
      prizes {
        prizes {
          id
          name
          category
          url
        }
      }
      winner {
        user {
          userId
          displayName
          avatarData
        }
        bid
        awardPrizeStatuses {
          prizeId
          success
          prizeCode
        }
      }
      extendedEndTime
    }
  }
`;

export const SUBSCRIPTION_AUCTION_UPDATE = gql`
  subscription AuctionUpdate {
    auctionUpdates {
      auctionId
      event
      name
      description
      enabled
      startTime
      endTime
      minimumBid
      bidIncrement
      prizes {
        prizes {
          id
          name
          category
          url
        }
      }
    }
  }
`;

export const MUTATION_ADD_BID = gql`
  mutation createAuctionBid($input: CreateAuctionBidInput!) {
    createAuctionBid(input: $input) {
      auctionId
      lastModified
    }
  }
`;

export const QUERY_GET_WSCORE = gql`
  query {
    patronAssets {
      wscore
    }
  }
`;

export const SUBSCRIPTION_UPDATED_CURRENCY_ITEM_BALANCES = gql`
  subscription {
    updatedCurrencyItemBalances {
      wscoreBalance
    }
  }
`;
